<template>
  <v-dialog
    v-model="sysloading"
    persistent
    width="300"
    content-class="loading-progress"
    >
    <div style="text-align: center">
      <!-- <v-progress-circular class="" indeterminate></v-progress-circular> -->
      <span><i class="v-icon-spin5 v-icon-loading-easy-table animate-loading-23" style="font-size: 28px;"></i></span>
    </div>
  </v-dialog>
</template>
<script>
import { mapState } from 'vuex'
import Vue from 'vue'

export default {
    name: 'system-progress',
    props: {                  
      sysloadingTitle: {
        type:String,
        required: true,
        default: "Please stand by"
      },      
      sysloading: {        
        required: true,
        default: false
      }
    },
    data () {
      return {
        mini: false,
        isRootComponent: true,
        // clipped: false,
        drawer: true,
        fixed: false
      }
    },
    methods: {
      onConfirm () {}      
    },
    mounted () {      
    }
  }
</script>

<style>
.loading-progress {
  top: 45% !important;
  -webkit-box-shadow: none;
  box-shadow: none;
  overflow-y: hidden;
}
</style>